module.exports = __webpack_public_path__ + "img/logo (6).62109678.png";